<template>
  <div>
    <nav-bar @side-menu-pressed="toggleNavDrawer" />
    <nav-drawer
      :side-nav="toggle"
      :is-logged-in="isLoggedIn"
      @update-navigation-prop="updateDrawerProp"
    />
  </div>
</template>
<script>
import NavBar from "@/components/Layout/NavBar";
import NavDrawer from "@/components/Layout/NavDrawer";
import safeAreaInsets from "safe-area-insets";
import {mapGetters} from "vuex";

export default {
  name: "Navigation",
  components: {
    NavDrawer,
    NavBar,
  },
  props: ["isLoggedIn"],
  data() {
    return {
      toggle: false,
    };
  },
  computed: {
    ...mapGetters(["isAuthenticated", "userProfileData"]),
  },
  mounted() {
    safeAreaInsets.onChange((newInsets) => {
      this.safeAreaOffset = newInsets.top;
    });
  },
  methods: {
    updateDrawerProp(value) {
      this.toggle = value;
    },
    toggleNavDrawer() {
      this.toggle = !this.toggle;
    },
  },
};
</script>
